import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {concat, Observable, of, Subject} from "rxjs";
import {NgSelectComponent} from "@ng-select/ng-select";
import {IgnoreNullHttpParams} from "../../Ignore-null-http-params";
import {HttpClient} from "@angular/common/http";
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from "rxjs/operators";
import {untilDestroyed} from "ngx-take-until-destroy";
import {Unit} from "../../../../generated-model/model";

@Component({
  selector: 'gt-unit-autocomplete',
  templateUrl: './gt-unit-autocomplete.component.html',
  styleUrls: ['./gt-unit-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: GtUnitAutocompleteComponent,
      multi: true
    }
  ]
})
export class GtUnitAutocompleteComponent implements ControlValueAccessor, OnInit {

  @Input()
  id: string;
  @Input()
  name: string;
  @Input()
  validateField: string;
  @Input()
  readonly: boolean = false;
  @Input()
  formState: string;
  @ViewChild("unitSelect", {static: true})
  _value = [];
  unitList$: Observable<Unit[]>;
  term$ = new Subject<string>();
  unitSelect: NgSelectComponent;
  typeaheadLoading = false;

  onChangeCallBack: (_: any) => void = () => {
  };
  onTouchCallBack: () => void = () => {
  };

  constructor(private _http: HttpClient) { }

  ngOnInit(): void {
    this.unitList$ = concat(
      of([]), // default items
      this.term$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => this.typeaheadLoading = true),
        switchMap(term => {
          return this.search(term)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => this.typeaheadLoading = false),
              untilDestroyed(this)
            );
        })
      )
    );
  }

  registerOnChange(fn: any): void {
    this.onChangeCallBack = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchCallBack = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  onModelChange(item: string) {
    this.value = item;
  }

  public clear() {
    this.unitSelect.handleClearClick();
    this.unitSelect.blur();
  }

  onSelectOpen() {
    this.term$.next('');
  }

  set value(val: any) {
    this._value = val;
    this.onChangeCallBack(val);
    this.onTouchCallBack();
  }

  get value(): any {
    return this._value;
  }

  ngOnDestroy(): void {

  }

  search(term: string): Observable<Unit[]> {
    return this._http.get<Unit[]>(`public/api/unit/th/search`,
      {params: IgnoreNullHttpParams.fromObject({term: term}).toHttpParam()}
    );
  }

}
